module.exports = __webpack_public_path__ + "assets/images/p5_3da64e950a8d1bb133a40f68871b4287.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/packs/p5.png
// module id = 129
// module chunks = 0